import styled from 'styled-components';

const StyledContainer = styled.div``;

export { StyledContainer };
